import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { FomentIndexService } from '../proxy/controlling/controllers/foment-index.service';

FieldBuilder.setNamespace('Controlling');

export const FOMENTINDEXVALUE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .number('year', 'Entity.FomentIndexValue.Year')
    .required()
    .build(),
  FieldBuilder
    .number('month', 'Entity.FomentIndexValue.Month')
    .build(),
  FieldBuilder
    .number('value', 'Entity.FomentIndexValue.Value')
    .required()
    .decimal(3,10)
    .build(),
  FieldBuilder.foreignKey(
    'fomentIndexId',
    'Entity.FomentIndex',
    FomentIndexService
  )
    .required()
    .displayFromNested('fomentIndex.name')
    .sortBy('fomentIndex.name')
    .build(),
];

export const FOMENTINDEXVALUE_CONFIG = {
  entityName: 'FomentIndexValue',
  localizationKey: 'Controlling::Entity.FomentIndexValue',
  fields: FOMENTINDEXVALUE_FIELDS,
  permission: 'ControllingLiquidations.FomentIndexValues',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
